import { render, staticRenderFns } from "./ChatIA.vue?vue&type=template&id=2406db54"
import script from "./ChatIA.vue?vue&type=script&lang=js"
export * from "./ChatIA.vue?vue&type=script&lang=js"
import style0 from "./ChatIA.vue?vue&type=style&index=0&id=2406db54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports